import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import {
  Button,
  Card,
  CardContent,
  Divider,
  Grid,
  Typography,
} from "@material-ui/core";
import { getRoleTitles } from "../../Services/API/UserManagement";
import { editPermissions } from "../../Services/API/UserManagement";
import PermissionForm from "../Form/PermissionForm";
import DropdownComponent from "../Dropdown/DropdownComponent";
import { CRMRoles } from "../../Constants/DropdownConstants";
import AutoCompleteComponent from "../AutoComplete/AutoComplete";

const useStyles = makeStyles((theme) => ({
  root: {
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
    justifyContent: "space-between",
    width: "100%",
    display: "flex",
    flexDirection: "column",
  },
  title: {
    [theme.breakpoints.down("sm")]: {
      fontSize: "18px",
      paddingLeft: "10px",
    },
    fontSize: "24px",
    paddingTop: "5%",
  },
  content: {
    paddingLeft: "20px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "space-between",
    height: "100%",
  },
  buttonSection: {
    display: "flex",
    justifyContent: "space-around",
    alignItems: "center",
    height: "50%",
    width: "100%",
  },
  button: {
    [theme.breakpoints.down("sm")]: {
      minWidth: "unset",
      minHeight: "unset",
      width: "30%",
    },
    minWidth: "200px",
    minHeight: "50px",
  },
  grid: {
    backgroundColor: "red",
  },
  error: {
    color: theme.palette.error.main,
  },
}));

const callAPI = (
  func,
  responseMessage,
  setResponseMessage,
  setShowError,
  setShowSignifier,
  populate
) => {
  func.then((res) => {
    setShowSignifier(true);
    if (res) {
      setResponseMessage(responseMessage);
      setShowError(false);
      populate();
    } else {
      setShowError(true);
    }
  });
};

const confirm = (
  closeModal,
  newRole,
  roleData,
  setResponseMessage,
  setShowError,
  setShowSignifier,
  baseClient,
  subjectId,
  populate,
  roleRights,
  crmRole
) => {
  var userId;
  var baseClientID;

  if (roleData !== undefined) {
    userId = roleData.userId;
    baseClientID = roleData.baseClientID;
  } else {
    userId = subjectId;
    baseClientID = baseClient.id;
  }
  callAPI(
    editPermissions(
      userId,
      newRole != null ? newRole.id : undefined,
      baseClientID,
      roleRights,
      crmRole
    ),
    "Role Saved",
    setResponseMessage,
    setShowError,
    setShowSignifier,
    populate
  );
  closeModal();
};

export default function PermissionsModal({
  setResponseMessage,
  setShowError,
  setShowSignifier,
  closeModal,
  client,
  roleData,
  populate,
  user,
}) {
  const classes = useStyles();
  let location = useLocation();
  const subject = user ?? location.state;
  const [newRole, setNewRole] = useState(
    roleData !== undefined && roleData.role !== null ? roleData.role : null
  );

  const [roles, setRoles] = useState([]);
  const [roleRights, setRoleRights] = useState(0);
  const [currentCrmRole, setCurrentCrmRole] = useState(CRMRoles[0]);

  useEffect(() => {
    getRoleTitles().then((roles) => {
      let filteredRoles = [];
      filteredRoles = roles.filter(
        (r) => r.name !== "Feeds Admin" && r.name !== "Outbound Feeds Admin"
      );
      setRoles(filteredRoles);
      if (roleData !== undefined) {
        setNewRole(roleData.role);
        setCurrentCrmRole(CRMRoles[roleData.crmRole]);
        if (roleData.rightsFlag === null) {
          setRoleRights(0);
        } else {
          setRoleRights(roleData.rightsFlag);
        }
      } else {
        setNewRole(undefined);
      }
    });
  }, [roleData]);

  const getRole = () => {
    let role = null; // do not use undefined for <AutoCompleteComponent>. It will create an 'uncontrolled' state and raise a console error.

    if (newRole != null) {
      role = roles.find((r) => r.id === newRole.id);
    }

    return role;
  };

  return (
    <div className={classes.root}>
      <Grid>
        <Card>
          <CardContent>
            <Grid container spacing={1}>
              <Grid xs={12} sm={12} item>
                <Typography>
                  {subject.firstName}'s{" "}
                  {client.clientName === undefined
                    ? client[0]
                    : client.clientName}{" "}
                  Permissions
                </Typography>
              </Grid>
              {client.hasCareers ? (
                <>
                  <Grid item xs={12} sm={12}>
                    <Divider></Divider>
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    {roles.length > 0 ? (
                      <AutoCompleteComponent
                        dropdownItems={roles}
                        propertyName="name"
                        label="Careers Role"
                        onChange={(e, value) => setNewRole(value)}
                        currValue={getRole()}
                      />
                    ) : null}
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <PermissionForm
                      roleId={
                        newRole != null ? newRole.id.toLocaleUpperCase() : ""
                      }
                      roleRights={roleRights}
                      setRoleRights={setRoleRights}
                    />
                  </Grid>
                </>
              ) : null}
              {client.hasCrm || client.hasCareers ? (
                <>
                  <Grid item xs={12} sm={12}>
                    <Divider></Divider>
                    <br></br>
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <DropdownComponent
                      currValue={currentCrmRole}
                      items={CRMRoles}
                      property="name"
                      title="CRM Role"
                      handleChange={(value) => setCurrentCrmRole(value)}
                      multi={false}
                    />
                  </Grid>
                </>
              ) : null}
              <Grid
                container
                justifyContent="flex-end"
                direction="row"
                style={{ marginRight: "10px" }}
              >
                <Grid item xs={6} sm={3}>
                  <Button
                    style={{ color: "#82B288", marginTop: "20px" }}
                    type="submit"
                    variant="outlined"
                    onClick={() => closeModal()}
                    fullWidth
                  >
                    Cancel
                  </Button>
                </Grid>
                <Grid item xs={6} sm={3}>
                  <Button
                    style={{ marginTop: "20px", marginLeft: "10px" }}
                    type="submit"
                    variant="contained"
                    color="primary"
                    onClick={() =>
                      confirm(
                        closeModal,
                        newRole,
                        roleData,
                        setResponseMessage,
                        setShowError,
                        setShowSignifier,
                        client,
                        subject.id,
                        populate,
                        roleRights,
                        currentCrmRole.value
                      )
                    }
                    fullWidth
                  >
                    Save
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    </div>
  );
}